module.exports = __webpack_public_path__ + "img/14.2.TN.f4d84db7.png";